import { ReceiptScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <ReceiptScreen />;
}
